import { useEffect } from "react";
import { FORMAT_TEXT_COMMAND } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { isSelectionInTable } from "../../../utils/isSelectionInTable";

export function DisableFormattingPlugin({
  formats = ["bold", "italic"],
}: {
  formats?: ("bold" | "italic" | string)[];
}) {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerCommand(
        FORMAT_TEXT_COMMAND,
        (format: string) => {
          const inTable = isSelectionInTable();
          if (inTable && formats.includes(format)) return true;
          return false;
        },
        1,
      ),
    [editor, formats],
  );

  return null;
}
